export default __webpack_public_path__ + "images/dog_alinasink-0fdc54bc37993f6097c989f9177dc877.jpg";